export default __webpack_public_path__ + "static/media/plus-icon.587ea93a.svg";